import React, { useEffect, useState } from 'react'
import Tabs from 'components/shared/Tabs'
import useGetIndexByQuery from 'sdk/hooks/search/useGetIndexByQuery'
import styles from './styles.module.scss'
import ExpertGrid from './ExpertGrid'
import NotFound from './NotFound'
import uniqueList from '../../../sdk/utils/uniqueList';

enum View { All, Stocks, ETFs, Crypto, NFTs }
const items = [
  { title: 'All', id: View.All },
  { title: 'Stocks', id: View.Stocks },
  { title: 'ETFs', id: View.ETFs },
  { title: 'Crypto', id: View.Crypto },
]

type Props = { search: string }

export function TabExperts({ search }: Props) {
  const [view, setView] = useState<View>(View.All)
  const selectedCategory = items?.find((i) => i.id === view)?.title
  const [searchData, setSearchData] = useState<any[] | null>(null);

  const {
    mutate: getIndex,
    data, isLoading, isSuccess,
  } = useGetIndexByQuery()

  useEffect(() => {
    if (search !== undefined) {
      getIndex({ query: search, index: 'salons_profiles', category: selectedCategory === 'All' ? '' : selectedCategory })
    }
  }, [search, view])

  useEffect(() => {
    if (isSuccess) {
      setSearchData(data);
    }
  }, [data, isSuccess])

  return (
    <div>
      <Tabs
        className={styles.tabs}
        items={items}
        onSelect={setView}
        value={view}
        simple
      />
      <div className={styles.main}>
        <ExpertGrid data={uniqueList(searchData ?? [], 'objectID').slice(0, 4)} loading={isLoading} />
        { data?.length === 0 && <NotFound text="Unfortunately, experts not found" /> }
      </div>
    </div>
  )
}
